import {axiosRequest} from "./apiBase";
import {PasswordReset} from "../common/models/userProfile/passwordReset.model";

export const userUpdatePassword = async (passwordProps: PasswordReset): Promise<PasswordReset> => {
    return axiosRequest(
        "POST",
        `user/updateUserPassword`,
        passwordProps
    );
};

export const userForgotPassword = async (email: string): Promise<void> => {
    return axiosRequest(
        "POST",
        `user/forgotPassword?email=${email}`
    );
};

export const unsubscribeFromMarketing = async (token: string): Promise<void> => {
    return axiosRequest(
        "POST",
        `user/unsubscribe?token=${token}`
    );
};